import { createContext, useContext } from "react";

const AuthContext = createContext(null);

export function AuthProvider({ currentUser, currentTenant, onLogout, refreshTenant, children }) {
  return (
    <AuthContext.Provider value={{ currentUser, currentTenant, onLogout, refreshTenant }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
}
